import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import './scss/main.scss'
import i18n from './i18n'
import Api from './api'
import User from './user'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(Api)
Vue.use(User)

new Vue({
  router,
  store,
  i18n,
  api: new Api({}),
  render: h => h(App)
}).$mount('#app')
